import { createAction, props } from '@ngrx/store';
import { IAskForQuotation, IQuotation, IQuotationDetail } from '../models/quotes.models';

// get quotations
export const GetQuotations = createAction('[ AskForQuotation ] - GetQuotations');
export const GetQuotationsSuccess = createAction(
  '[ AskForQuotation ] - GetQuotations Success ',
  props<{ quotations: IQuotation[] }>()
);
export const GetQuotationsError = createAction('[ AskForQuotation ] - GetQuotations Error');

// get quotation by id
export const GetQuotationById = createAction(
  '[ Quotation ] - GetQuotationById',
  props<{ id: number }>()
);
export const GetQuotationByIdSuccess = createAction(
  '[ Quotation ] - GetQuotationById Success ',
  props<{ quotation: IQuotationDetail }>()
);
export const GetQuotationByIdError = createAction('[ Quotation ] - GetQuotationById Error');

// add ask_for_quotation
export const AddAskForQuotation = createAction(
  '[ AskForQuotation ] - AddAskForQuotation',
  props<{ ask_for_quotation: IAskForQuotation }>()
);
export const AddAskForQuotationSuccess = createAction(
  '[ AskForQuotation ] - AddAskForQuotation Success ',
  props<{ ask_for_quotation: IQuotation }>()
);
export const AddAskForQuotationError = createAction(
  '[ AskForQuotation ] - AddAskForQuotation Error'
);

// draft ask_for_quotation
export const DraftAskForQuotation = createAction(
  '[ DraftAskForQuotation ] - DraftAskForQuotation',
  props<{ ask_for_quotation: IAskForQuotation }>()
);
export const DraftAskForQuotationSuccess = createAction(
  '[ DraftAskForQuotation ] - DraftAskForQuotation Success ',
  props<{ ask_for_quotation: IQuotation }>()
);
export const DraftAskForQuotationError = createAction(
  '[ DraftAskForQuotation ] - DraftAskForQuotation Error'
);

// edit and ask_for_quotation
export const EditAndAskForQuotation = createAction(
  '[ EditAndAskForQuotation ] - EditAndAskForQuotation',
  props<{ id: number; ask_for_quotation: IAskForQuotation }>()
);
export const EditAndAskForQuotationSuccess = createAction(
  '[ EditAndAskForQuotation ] - EditAndAskForQuotation Success ',
  props<{ ask_for_quotation: IQuotation }>()
);
export const EditAndAskForQuotationError = createAction(
  '[ EditAndAskForQuotation ] - EditAndAskForQuotation Error'
);

// send request
export const SendRequest = createAction('[ SendRequest ] - SendRequest', props<{ id: number }>());
export const SendRequestSuccess = createAction(
  '[ SendRequest ] - SendRequest Success ',
  props<{ quotation: IQuotation }>()
);
export const SendRequestError = createAction('[ SendRequest ] - SendRequest Error');

// accept quotation
export const AcceptQuotation = createAction(
  '[ AcceptQuotation ] - AcceptQuotation',
  props<{ id: number }>()
);
export const AcceptQuotationSuccess = createAction(
  '[ AcceptQuotation ] - AcceptQuotation Success ',
  props<{ quotation: IQuotation }>()
);
export const AcceptQuotationError = createAction('[ AcceptQuotation ] - AcceptQuotation Error');

// decline quotation
export const DeclineQuotation = createAction(
  '[ DeclineQuotation ] - DeclineQuotation',
  props<{ id: number }>()
);
export const DeclineQuotationSuccess = createAction(
  '[ DeclineQuotation ] - DeclineQuotation Success ',
  props<{ quotation: IQuotation }>()
);
export const DeclineQuotationError = createAction('[ DeclineQuotation ] - DeclineQuotation Error');

// clear quote
export const clearQuotation = createAction('[ ClearQuote ] - ClearQuote');
